<template>
        <v-row justify="center">
            <v-list-item

                         color="primary"
                         dark
                         @click="fetchInterview"
            >

                <v-list-item-icon>
                    <v-img src="../../../../../../assets/svg/complaint.svg" class="invite-box"></v-img>
                </v-list-item-icon>


                <v-list-item-content>
                        <v-list-item-title class="comment">View Completed Interview </v-list-item-title>
                    </v-list-item-content>
            </v-list-item>


            <v-dialog
                    v-model="dialog"
                    width="450"
            >
                <v-card>
                    <Loader :loading="loading" :message="message"/>
                    <v-toolbar class="box"  @click.stop="dialog = false">
                        <v-icon>mdi-close</v-icon>
                        <v-toolbar-title>Close</v-toolbar-title>
                    </v-toolbar>
                    <div class="comment-content">
                        <div>{{serverResponse}}</div>
                        <v-card-title class="comment-heading">Interview Session of {{applicant.firstName}} {{applicant.lastName}} </v-card-title>

                        <v-card-text class="comment-info">
                            <p class="pa-0">Interviewed by {{interviewer}}</p>
                            <p class="pa-0">{{dateAndTimeOfInterview}}</p>
                        </v-card-text>
                        <v-row>
                            <div v-for="(interview1, index) in interviewListKeys" :key="interview1._id" class="adminid textareaComment" :style="[interview1==='interviewDecision'?{border:'none'}:{border: '1px solid rgba(150, 12, 12, 0.5)'}]">
                                <div v-if="interview1==='interviewDecision'">
                                    <p class="decision pa-0 mb-0">{{interviewer}}'s Decision</p>
                                    <div class=" ml-0 pl-0 date-and-time-input-box decisionRec" style=" margin-left: 1px" >
                                        <p class="decidetext">{{interviewList[index]}}</p>
                                        <img  class="decision-radio" src='../../../../../../assets/svg/check-circle.svg' alt="logo" />


                                    </div>
                                </div>
                                <div v-else>
                                <p class="question font-weight-bold pa-0">{{interview1}}</p>
                                <p class="response pa-0" >{{interviewList[index] }}</p>
                                </div>
                            </div>
                            <div v-if="this.applicant.applicationStatus==='INTERVIEWED'" class="final">
                              <p class="make-final"> Make Final Decision</p>
                              <div class=" date-and-time-input-box decisionRec mb-2 " v-on:click="sendOffer">
                                <p class="decidetext">Offer Admission </p>
                                <img v-if="decision==='OFFERED_ADMISSION'" class="decision-radio"
                                     src='../../../../../../assets/svg/check-circle.svg' alt="logo"/>
                                <img v-else class="decision-radio" src='../../../../../../assets/svg/uncheck-icon.svg'
                                     alt="logo"/>

                              </div>

                              <div class=" date-and-time-input-box decisionRec mb-2 " v-on:click="sendToCommunity">
                                <p class="decidetext">Send to Community</p>
                                    <img v-if="decision==='SEND_TO_COMMUNITY'" class="send-radio" src="../../../../../../assets/svg/check-circle.svg" alt="logo"  />
                                    <img v-else class="send-radio" src="../../../../../../assets/svg/uncheck-icon.svg" alt="logo"  />

                                </div>


                                <div class="date-and-time-input-box decisionRec mb-2"  v-on:click="BlackList">
                                    <p class="decidetext">BLACKLIST</p>

                                    <img v-if="decision==='BLACKLIST'" class="blacklist-radio " src="../../../../../../assets/svg/check-circle.svg" alt="logo"/>

                                    <img class="blacklist-radio uncheck" v-else src="../../../../../../assets/svg/uncheck-icon.svg" alt="logo"/>

                                </div>
                                <div>
                                    <ValidationProvider name="Comment" rules="required" v-slot="{ errors }">
                                        <span class="err">{{ errors[0] }}</span>
                                    <v-textarea
                                            outlined
                                            name="input-7-4"
                                            row-height="15"
                                            auto-grow
                                            class="decision-input"
                                            label="Decision Comment"
                                            v-model="decisionComment"
                                    ></v-textarea>
                                    </ValidationProvider>
                                </div>
                            </div>
                          <div v-else>
                            <p class="decision pa-0 mb-0 ml-3 ">Final Decision Made</p>

                            <div  class="adminid textareaComment pl-0 date-and-time-input-box decisionRec" style="width: 320px!important; margin-left: 1px" >
                              <p class="decidetext">{{finalDecision}}</p>
                              <img  class="decision-radio" src='../../../../../../assets/svg/check-circle.svg' alt="logo" />
                            </div>

                          </div>

                            <v-card-actions>
                                <v-btn
                                        color="red"
                                        outlined
                                        x-large
                                        @click="dialog=false"
                                >
                                    Cancel
                                </v-btn>

                                <v-btn
                                        color="error"
                                        depressed
                                        x-large
                                        @click="makeFinalDecision"
                                        class="ml-5"
                                >
                                    Submit
                                </v-btn>
                            </v-card-actions>

                        </v-row>


                    </div>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
import axios from 'axios'
import {mapGetters} from "vuex";
import Loader from "../Loader";

import {getCompletedInterview, makeFinalApplicationDecision} from "../../../../../../services/ApiServices";

export default {
  name: "ViewCompletedInterview",
  components: {Loader},
  props: ['applicantRecord'],
  data() {
    return {
      dialog: false,
      interview: "",
      interviewList: "",
      interviewListKeys: '',
      loading: false,
                interviewer:'',
                message:"Loading...",
                dateAndTimeOfInterview:'',
                serverResponse:'',
                decision:'',
                decisionComment:'',
              finalDecision:'',



            }
        },
        methods:{

            fetchInterview(){
                this.dialog=true
                this.loading=true
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                console.log(this.applicantEmail)
                axios.get(getCompletedInterview(this.applicantEmail),{headers:elderHeader})
                .then(res=>{
                    console.log(res)
                    this.interviewer = res.data.interviewedBy
                  this.finalDecision = res.data.finalInterviewDecision
                    this.dateAndTimeOfInterview = res.data.dateAndTimeOfInterview
                    this.interviewList = Object.values(res.data.interviewComments);
                    this.interviewListKeys = Object.keys(res.data.interviewComments) ;
                    console.log(this.interviewListKeys)
                    this.loading = false

                })
                .catch(err=>{
                    console.log(err)
                    if(err.response===undefined){
                        this.serverResponse = "Check your internet and try again"
                    }
                    else{
                        this.serverResponse = err.response.data.message
                    }
                    this.loading=false
                })
            },
            sendOffer: function () {
                this.decision ='OFFERED_ADMISSION'

            },
            sendToCommunity:function () {
                this.decision='SEND_TO_COMMUNITY'
            },
            BlackList:function () {
                this.decision='BLACKLIST'

            },
            makeFinalDecision(){
                this.loading=true
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                axios.post(makeFinalApplicationDecision(this.applicantEmail,),{
                    decision:this.decision,
                    decisionComment:this.decisionComment

                },{headers:elderHeader})
                .then(res=>{
                    this.serverResponse = res.data.message
                    this.dialog=false
                    this.$store.dispatch('fetchApplicantByEmail',this.applicantEmail)
                }).catch(err=>{
                    if(err.response===undefined){
                        this.serverResponse='Check your internet connection and try again'
                    }else{
                        this.serverResponse = err.response.data.method
                    }
                    this.loading=false
                })

            }

        },


        computed:{
        ...mapGetters(['applicantEmail','applicant',])
        }

    }
</script>

<style scoped>
    .comment{
        font-family: IBM Plex Sans !important;
        font-style: normal !important ;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 18px !important;
        display: flex;
        align-items: center !important;
        letter-spacing: 0.02em;
        color: #431288;
    }
    .comment-box{
        background: rgba(67, 18, 136, 0.2);
        border-radius: 8px;
        padding: 3px;
    }
    .comment-heading{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 36px;
        letter-spacing: -0.02em;

        color: #2B1C1C;
    }
    .err{
        color: red;
    }
    .comment-info{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 21px;
        color: #2B1C1C;
    }
    .comment-input{
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center!important;
        letter-spacing: 0.05em;

        color: #2B1C1C !important;
    }
    .box{
        box-shadow: none!important;
        cursor: pointer;
    }
    .comment-content{
        margin-left: 55px;
        margin-right: 55px;
        font-family: IBM Plex Sans !important;
        font-style: normal!important;
        font-weight: normal;

    }
    .textareaComment{
        width: auto !important;
        min-width: 320px !important;
        margin-left: 15px !important;
        height: auto !important;
        margin-top: 10px !important;
        border: 1px solid rgba(150, 12, 12, 0.5);
        box-sizing: border-box;
        border-radius: 6px;
        background-color: #ffffff;
        resize: none;
        overflow: auto;
        margin-bottom: 12px !important;
        padding-left: 10px;
        overflow-y: hidden !important;
        padding-top: 10px;
    }
    .adminid{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.01em;


    }
    .response{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        letter-spacing: 0.01em;
        word-break: break-all;
        word-wrap: break-word;
        color: #2B1C1C;
    }
    .question{
        font-family: IBM Plex Sans;
        font-weight: bolder;
        font-style: normal;
        font-size: 13px;
        line-height: 19px;
        display: flex;
        align-items: center;
        letter-spacing: 0.01em;

        color: #2B1C1C !important;
    }
    .date-and-time-input-box {
        display: flex;
        border: 1.5px solid rgba(150, 12, 12, 0.5);
        max-width: 320px;
        margin-left: -17px;
        border-radius: 6px;
        align-items: center;
        overflow-y: hidden !important;
        /*margin-bottom: 15px;*/
    }
    .date-and-time-input-box img {
        width: 20px;
        height: 20px;
        flex: 1;
    }
    .decidetext{
        margin-top: 12px !important;
        margin-left: 10px;


    }
    .decision{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 32px;
        /*margin-left: -17px;*/

        /* identical to box height, or 112% */
        letter-spacing: -0.02em;

        color: #2B1C1C;


    }
    .decisionRec{
        box-shadow: 0px 8px 12px rgba(108, 132, 120, 0.1);

    }
    .blacklist-radio{

        margin-left: 110px !important;

    }
    .final{
        margin-bottom: 15px;
        width: 330px;
        margin-left: 35px;
        /*color: #960C0C;*/
    }
    .make-final{
        color: #960C0C;
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 32px;

        /* identical to box height, or 112% */
        letter-spacing: -0.02em;
    }
    .uncheck .decisionRec{
        border: 1px solid rgba(43, 28, 28, 0.25)!important;
    }

    .send-radio{
        margin-left: 58px !important;
    }

    .decision-radio{

        margin-left: 80px !important;

    }
    .decision-input{
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center!important;
        letter-spacing: 0.05em;
        width: 320px !important;
        margin-top: 10px !important;
        margin-left: -15px !important;
        /*height: 92px !important;*/
        color: #2B1C1C !important;
    }

</style>s